import { loadStripe } from '@stripe/stripe-js';
import { PageTitle } from "./Controls/PageTitle";
import { Col, Container, Row, Button } from "react-bootstrap";
import { useSearchParams, useNavigate } from "react-router-dom";

//must be outside of a component
//do we need this in more of a central place?
//can it be safely called more than once I wonder?
const stripePromise = loadStripe( import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY! );

export function UserBillingAddSuccessPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const nav = useNavigate();
    const [ setupIntent, setupIntentClientSecret, redirectStatus, returnTo, returnLabel ] = [
        searchParams.get( "setup_intent" ),
        searchParams.get( "setup_intent_client_secret" ),
        searchParams.get( "redirect_status" ),
        searchParams.get( "returnTo" ),
        searchParams.get( "returnLabel" )
    ];
    console.log( setupIntent             );
    console.log( setupIntentClientSecret );
    console.log( redirectStatus          );
    return <Container>
        <Row>
            <Col>
                <PageTitle>
                    Add Payment Method
                </PageTitle>
                { redirectStatus === "succeeded" && <>
                    Your payment settings were successfully updated!
                    <div>
                        <Button className="mt-4" onClick={() => nav(returnTo ?? "/user/billing")}>
                            {returnLabel ?? 'Go to billing overview'}
                        </Button>
                   </div>
                    </>}
            </Col>
        </Row>
    </Container>
};